export class UserLoginResult {
  super = false;
  message = "";
  success = false;
}
